export interface ColumnMetadataObject {
  field: string;
  headerName: string;
  flex: number;
}

export type Credential = {
  app: string;
  metadata?: string;
  credentials: {
    username: string;
    password: string;
  };
};
export type CredentialLookup = {
  [app: string]: Credential;
};

export type Videos = {
  [app: string]: string;
};

export interface Skill {
  skill_id: string;
  skill_name: string;
  url: string;
  permacode: string;
  subject: string;
  grade: string;
  subject_id: number;
}

export type CombinedSkill = Skill & {
  app: string;
  content: string;
};

// Skills/tests are gonna be merged at some point but are different data for now
export interface Recommendation {
  block: string; // subject
  created_on: string; // ISO timestamp
  updated_on: string; // ISO timestamp
  grade: string;
  invalidated_on: string | null; // ISO timestamp
  name: string;
  priority: number;
  recommendation_id: number;
  smart_score: number;
  source_id: number;
  status: string;
  student_id: string;
  subject_id: number;
  suggested_content: string; // HTML links for now
  type: string; // "learn" or something else?
  url: string;
  uuid: string;
  completed_on: string | null; // ISO timestamp
  application: string;
  skill_id: string;
  recommendation_source: string;
  sso_url: string;
}

export enum SubBlockType {
  TEST = 'test',
  LEARN = 'learn',
}

// A collection of skills and tests
export interface SubBlock {
  type: SubBlockType;
  rows: Recommendation[];
}

// A collection of subBlocks with a description
export interface Block {
  subject: string;
  description: string;
  isEligibleForTest?: boolean;
  subBlocks: SubBlock[];
}

export interface MyRecommendationsOutput {
  recommendations: Block[];
  recommendations_title?: string;
}

export interface SubjectMetadata {
  subject: string;
  subjectNameOverride?: string;
  description: string;
}

export interface SubmitRecommendations {
  // Google spread sheet link
  link: string;
  sheetName: string;
}

export interface SubmitRecommendationResult {
  student_id?: number;
  priority: string;
  source_id: number;
  subject_id?: number;
  name: string;
  apiStatus: 'created' | 'updated' | 'error';
  uuid?: string;
  error?: string;
}

export interface SubmitRecommendationsErrorResult {
  message: string;
  stack?: string;
}

export interface FormSubmitResult extends SubmitRecommendations {
  isSuccess: boolean;
  error?: SubmitRecommendationsErrorResult;
  recommendations: SubmitRecommendationResult[];
}

export type CompetitionOnboardingStatusEnum =
  | 'screener'
  | 'pick_grade'
  | 'pre_map_recommendations'
  | 'recommendations'
  | 'map';

export type CompetitionOnboardingStatus = {
  campus_id: string;
  student_id: string;
  full_student_id: string;
  competition: string;
  original_age_grade: number;
  screener_overall_result: number | null;
  competition_grade: number | null;
  onboarding_stage: CompetitionOnboardingStatusEnum;
  onboarding_status?: string | null;
  khan_account_created: number; // AI-GEN - Cursor - GPT4
  khan_math_class_link: string; // AI-GEN - Cursor - GPT4
  created_on: string;
  updated_on: string;
};

export type TwoHourOnboardingStatus = {
  student_id: string;
  onboarding_type: string;
  onboarding_stage: string;
  onboarding_status?: null;
  khan_account_created: boolean;
  khan_math_class_link: string | null;
  original_age_grade: number;
  created_on: string;
  updated_on: string;
};
